module.exports = __webpack_public_path__ + "img/logo.d97bbcb7.png";